/* src/components/Profile/ProfileAbout.jsx */
import React from 'react';
import './ProfileComponents.css'; // We will create a shared CSS file

const ProfileAbout = ({ profile }) => {
    if (!profile) return null;

    // Formatting Dates
    const joinDate = profile.createdAt ? new Date(profile.createdAt).toLocaleDateString() : null;
    const birthDate = profile.birthdate ? new Date(profile.birthdate).toLocaleDateString() : null;

    return (
        <div className="about-section fade-in">
            <div className="info-card">
                <h3>Details</h3>

                {/* Username (Always Public) */}
                <InfoRow label="Username" value={`@${profile.username}`} />

                {/* Conditional Fields (Backend sends null if hidden) */}
                <InfoRow label="Joined" value={joinDate} />
                <InfoRow label="Email" value={profile.email} />
                <InfoRow label="Location" value={profile.location} />
                <InfoRow label="Birthday" value={birthDate} />
            </div>
        </div>
    );
};

// Helper Sub-component for cleaner rows
const InfoRow = ({ label, value }) => {
    if (!value) return null;
    return (
        <div className="info-row">
            <span className="label">{label}</span>
            <span className="value">{value}</span>
        </div>
    );
};

export default ProfileAbout;